/** Stable codes returned on `error` when `rsSDK('collect')`, `rsSDK('submit')` or `rsSDK('bb:collect')` fails. */
export const SDK_ERROR = {
  MISSING_CONFIG: 'missing_config',
  BROWSER_ONLY: 'browser_only',
  UNSUPPORTED_MODE: 'unsupported_mode',
  NOTHING_TO_COLLECT: 'nothing_to_collect',
  NOTHING_TO_SUBMIT: 'nothing_to_submit',
  NO_DEVICE_DATA: 'no_device_data',
  BB_DISABLED: 'bb_disabled',
  BB_AUTO: 'bb_auto',
  BB_NOT_RUNNING: 'bb_not_running',
  TIMEOUT: 'timeout',
  NETWORK_ERROR: 'network_error',
  ABORTED: 'aborted',
  HTTP_ERROR: 'http_error',
  COLLECT_FAILED: 'collect_failed',
  SUBMIT_FAILED: 'submit_failed',
  BB_FAILED: 'bb_failed',
};

export const SDK_WARNING = {
  NO_DEVICE_DATA: 'no_device_data',
  NO_BEHAVIOUR_DATA: 'no_behaviour_data',
};

const POST_FAILURE_CODE = {
  timeout: SDK_ERROR.TIMEOUT,
  network: SDK_ERROR.NETWORK_ERROR,
  abort: SDK_ERROR.ABORTED,
  http: SDK_ERROR.HTTP_ERROR,
};

/**
 * Map a thrown collect/bb failure to a public error code.
 * Transport failures use `err.rsPostFailure.type`. Anything else uses `fallback`.
 * @param {unknown} err
 * @param {string} fallback
 * @returns {string}
 */
export function errorCodeFrom(err, fallback) {
  const type = err && typeof err === 'object' && err.rsPostFailure && err.rsPostFailure.type;
  if (type && POST_FAILURE_CODE[type]) return POST_FAILURE_CODE[type];
  return fallback;
}
